import { DeviceType } from '../../../../../types';

// enums that are used by types are co-located with the consuming type

export enum QualityMode {
  High = 'high',
  Medium = 'medium',
  Low = 'low',
}

export enum MediaSource {
  Camera = 'camera',
  Screen = 'screen',
  Microphone = 'microphone',
}

export type MediaMetadata = {
  deviceType?: DeviceType;
  qualityMode?: QualityMode;
  source: MediaSource;
  shortId?: string;
};

export type MediaKind = 'audio' | 'video' | 'data';

export type AudioVideoMediaKind = Extract<MediaKind, 'audio' | 'video'>;
